module.exports = __webpack_public_path__ + "img/1.a52b966a.jpg";